import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc164108"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about d-flex flex-column justify-content-between flex-md-row" }
const _hoisted_2 = { class: "about-left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Demystifying Islamic Finance", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " The goal of islamic finance is to make life easier and we believe everyone should have access to money at the time they need it without exorbitant interest rates that makes it hard to return, ", -1))
const _hoisted_5 = { class: "about-right" }
const _hoisted_6 = { class: "about-img-1" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "about-img-2" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "position-absolute img-roll" }
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_router_link, { to: "/our-culture" }, {
        default: _withCtx(() => [
          _createVNode(_component_Button, {
            svg: "",
            icon: "arrow-right",
            name: "See how we do it",
            type: "blue"
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("img", {
          src: require('@/assets/Character.png'),
          alt: "vault",
          class: "w-100 h-100"
        }, null, 8, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("img", {
          src: require('../assets/Vault.png'),
          alt: "vault",
          class: "w-100 h-100"
        }, null, 8, _hoisted_9),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("img", {
            src: require('../assets/lock.png'),
            alt: "lock",
            class: "w-100 h-100"
          }, null, 8, _hoisted_11)
        ])
      ])
    ])
  ]))
}